var _rect, _path, _path2, _path3, _circle, _circle2, _circle3, _rect2, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFonte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 21,
    width: 48,
    height: 30,
    stroke: "#A80A01",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 36C37.5 41.799 32.799 46.5 27 46.5C21.201 46.5 16.5 41.799 16.5 36C16.5 30.201 21.201 25.5 27 25.5C32.799 25.5 37.5 30.201 37.5 36Z",
    stroke: "#A80A01",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.812 31.1272C29.9913 31.2309 30.2207 31.1697 30.3244 30.9904C30.4281 30.8111 30.3669 30.5817 30.1876 30.478L29.812 31.1272ZM24.1876 40.8726C24.0083 40.7689 23.7789 40.8302 23.6752 41.0095C23.5715 41.1888 23.6328 41.4181 23.812 41.5219L24.1876 40.8726ZM24.8785 33.8786L25.1437 34.1438L24.8785 33.8786ZM32.6248 35.9999C32.6248 39.1065 30.1064 41.6249 26.9998 41.6249V42.3749C30.5206 42.3749 33.3748 39.5208 33.3748 35.9999H32.6248ZM21.3748 35.9999C21.3748 32.8933 23.8932 30.3749 26.9998 30.3749V29.6249C23.479 29.6249 20.6248 32.4791 20.6248 35.9999H21.3748ZM26.9998 30.3749C28.025 30.3749 28.9851 30.6489 29.812 31.1272L30.1876 30.478C29.2495 29.9354 28.1604 29.6249 26.9998 29.6249V30.3749ZM31.0687 32.1161C32.0331 33.1261 32.6248 34.4935 32.6248 35.9999H33.3748C33.3748 34.293 32.7035 32.7421 31.6112 31.5981L31.0687 32.1161ZM26.9998 41.6249C25.9746 41.6249 25.0146 41.351 24.1876 40.8726L23.812 41.5219C24.7501 42.0645 25.8393 42.3749 26.9998 42.3749V41.6249ZM23.0149 39.97C22.0009 38.9522 21.3748 37.5496 21.3748 35.9999H20.6248C20.6248 37.756 21.3353 39.3467 22.4836 40.4993L23.0149 39.97ZM24.3748 35.9999C24.3748 35.275 24.6682 34.6192 25.1437 34.1438L24.6133 33.6135C24.003 34.2238 23.6248 35.0681 23.6248 35.9999H24.3748ZM25.1437 34.1438C25.6191 33.6683 26.2748 33.3749 26.9998 33.3749V32.6249C26.0679 32.6249 25.2237 33.0031 24.6133 33.6135L25.1437 34.1438ZM25.1437 33.6135L19.8404 28.3102L19.31 28.8405L24.6133 34.1438L25.1437 33.6135ZM26.9998 33.3749C27.7248 33.3749 28.3805 33.6683 28.856 34.1438L29.3863 33.6135C28.776 33.0031 27.9317 32.6249 26.9998 32.6249V33.3749ZM28.856 34.1438C29.3314 34.6192 29.6248 35.275 29.6248 35.9999H30.3748C30.3748 35.0681 29.9966 34.2238 29.3863 33.6135L28.856 34.1438ZM34.1593 28.3102L28.856 33.6135L29.3863 34.1438L34.6896 28.8405L34.1593 28.3102ZM34.6896 43.1594L29.3863 37.8561L28.856 38.3864L34.1593 43.6897L34.6896 43.1594ZM29.6248 35.9999C29.6248 36.7249 29.3314 37.3807 28.856 37.8561L29.3863 38.3864C29.9966 37.7761 30.3748 36.9318 30.3748 35.9999H29.6248ZM28.856 37.8561C28.3805 38.3315 27.7248 38.6249 26.9998 38.6249V39.3749C27.9317 39.3749 28.776 38.9968 29.3863 38.3864L28.856 37.8561ZM24.6133 37.8561L19.31 43.1594L19.8404 43.6897L25.1437 38.3864L24.6133 37.8561ZM26.9998 38.6249C26.2748 38.6249 25.6191 38.3315 25.1437 37.8561L24.6133 38.3864C25.2237 38.9968 26.0679 39.3749 26.9998 39.3749V38.6249ZM25.1437 37.8561C24.6682 37.3807 24.3748 36.7249 24.3748 35.9999H23.6248C23.6248 36.9318 24.003 37.7761 24.6133 38.3864L25.1437 37.8561Z",
    fill: "#A80A01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27H45L42 30L45 33H51L54 30L51 27Z",
    stroke: "#A80A01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.75,
    cy: 30.75,
    r: 0.75,
    fill: "#A80A01"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.25,
    cy: 30.75,
    r: 0.75,
    fill: "#A80A01"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 29.25,
    r: 0.75,
    fill: "#A80A01"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 40.5,
    width: 9,
    height: 4.5,
    stroke: "#A80A01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40.5V45",
    stroke: "#A80A01",
    strokeWidth: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFonte);
export default __webpack_public_path__ + "static/media/Fonte.ee17dd66fbec17f7d28944e26568e9f0.svg";
export { ForwardRef as ReactComponent };